/**
 * @author PoornaChandu
 * @description added FieldDataType and Observation Type
 */
/* eslint-disable no-unused-vars */
import React, { Fragment, useState, useEffect, useRef } from 'react';
import { Form, Select, Popconfirm, Tooltip, Collapse, TimePicker, Input, message, Button } from 'antd';
import { DeleteOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import {
  getToolsList,
  getLaborList,
  getMaterialsList,
  checkTask,
  getItemsList,
  getSkillTypeList,
  _getUOMList,
  getUsersList
} from '../../../Utils/FormCalls';
// import FileBase641 from '../../../Utils/FileUploads';
import { connect } from 'react-redux';
import { constant } from '../../../Utils/constants';
import translation from '../../../../../commons/translation';
import InputComponent from '../../../Widgets/InputComponent';

import InputNumberComponent from '../../../Widgets/InputNumberComponent';
import dayjs from 'dayjs';
import { StyledBox } from '../../../CSS/style';
const { Option } = Select;
const { Panel } = Collapse;
const { TextArea } = Input;
const fileData = new FormData();
//@ATT:this was created to make nested dynamic elements! This is hard!
const ToolsFormFunction = (props) => {
  const [toolsList, setTool] = useState([]);
  const [translationCache, settranslationCache] = useState(props.translationCache || {});
  useEffect(() => {
    (async () => {
      try {
        let response = await getToolsList();
        setTool(response.data);
      } catch (e) {
        return {};
      }
    })();
  }, []);
  return (
    <>
      <Form.List name={'Tools'}>
        {(Tools, { add, remove }) => {
          return (
            <Fragment>
              <Form.Item>
                <div style={{ display: 'flex', justifyContent: 'right', margin: "10px 0px" }}>
                  <Button
                    type="primary"
                    onClick={() => {
                      add();
                    }}
                  >
                    {translation(translationCache, 'Add Tools')}
                  </Button>
                </div>
              </Form.Item>
              {Tools && Array.isArray(Tools) && Tools.length > 0 ? (
                <Collapse accordion defaultActiveKey={[]}>
                  {Tools.map((tool, index2) => (
                    <Panel
                      key={index2}
                      header={
                        <div style={{ fontWeight: 'bold' }}>
                          {`${translation(translationCache, constant.tools)} ${index2 + 1}`}
                        </div>
                      }
                      extra={
                        <Popconfirm
                          title={translation(translationCache, constant.deleteTool)}
                          icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                          onConfirm={() => remove(tool.name)}
                          okText={translation(translationCache, constant.yes)}
                          cancelText={translation(translationCache, constant.no)}
                        >
                          {' '}
                          <Tooltip
                            title={translation(translationCache, 'Delete')}
                            placement="bottom"
                          >
                            <DeleteOutlined />
                          </Tooltip>
                        </Popconfirm>
                      }
                    >
                      <StyledBox>
                        <Form.Item
                          label={translation(translationCache, constant.tool)}
                          {...tool}
                          name={[tool.name, 'ToolId']}
                          fieldKey={[tool.fieldKey, 'ToolId']}
                          key={index2}
                          rules={[
                            {
                              required: true,
                              message: 'Tool is Required'
                            }
                          ]}
                        >
                          <Select
                            style={{ width: '100%' }}
                            onChange={(value) =>
                              props.onToolChange(
                                value,
                                index2,
                                'Tools',
                                toolsList.filter((tool) => tool.Id === value)
                              )
                            }
                            placeholder={translation(translationCache, 'Select Tool')}
                          >
                            {toolsList.map((tool, index) => {
                              return (
                                <Option
                                  key={index}
                                  value={tool.Id}
                                  disabled={
                                    props.formHeader &&
                                      props.formHeader.current &&
                                      props.formHeader.current.getFieldValue() &&
                                      props.formHeader.current.getFieldValue().Tools &&
                                      props.formHeader.current
                                        .getFieldValue()
                                        .Tools.filter((item) => item && item.ToolId === tool.Id)
                                        .length > 0
                                      ? true
                                      : false
                                  }
                                >
                                  {' '}
                                  {tool.Tool}{' '}
                                </Option>
                              );
                            })}
                          </Select>
                        </Form.Item>
                        <Form.Item
                          label={translation(translationCache, constant.description)}
                          {...tool}
                          name={[tool.name, 'Description']}
                          fieldKey={[tool.fieldKey, 'Description']}
                          key={index2}
                        >
                          <InputComponent
                            //maxLength={20}
                            placeholder={translation(translationCache, 'Auto Populate from Tools')}
                            style={{ width: '100%' }}
                            disabled
                          />
                        </Form.Item>
                        <Form.Item
                          label={translation(translationCache, constant.Quantity)}
                          validateTrigger={['onChange', 'onBlur']}
                          {...tool}
                          name={[tool.name, 'Quantity']}
                          fieldKey={[tool.fieldKey, 'Quantity']}
                          key={index2}
                          rules={[
                            {
                              validator: (_, value) =>
                                checkTask(_, value, 'Tools', index2, props.formObject, {
                                  validateDecimal: true
                                })
                            }
                          ]}
                        >
                          <InputNumberComponent
                            disabled={
                              props &&
                                props.formObject &&
                                props.formObject.Tools &&
                                props.formObject.Tools[index2] === undefined
                                ? true
                                : false
                            }
                            placeholder={translation(translationCache, 'Input Quantity')}
                            style={{ width: '100%' }}
                            addonAfter={
                              <Tooltip
                                style={{ marginRight: '20px', flex: '50%' }}
                                labelCol={{ flex: '130px' }}
                                title={translation(
                                  translationCache,
                                  'AvailableQuantity  -  ' +
                                  (props &&
                                    props.formObject &&
                                    props.formObject.Tools &&
                                    props.formObject.Tools[index2] &&
                                    props.formObject.Tools[index2].AvailableQuantity
                                    ? props.formObject.Tools[index2].AvailableQuantity
                                    : 'Not Available')
                                )}
                              >
                                <QuestionCircleOutlined />
                              </Tooltip>
                            }
                          //maxLength={10}
                          />
                        </Form.Item>
                        <Form.Item name={[tool.name, 'AvailableQuantity']} />
                      </StyledBox>
                    </Panel>
                  ))}
                </Collapse>
              ) : null}
            </Fragment>
          );
        }}
      </Form.List>
    </>
  );
};
const LaborFormFunction = (props) => {
  const [laborsList, setLabor] = useState([]);
  const [SkilTypeList, setSkill] = useState([]);
  const [translationCache, settranslationCache] = useState(props.translationCache || {});
  useEffect(() => {
    (async () => {
      try {
        let response = await getLaborList();
        setLabor(response.data);
      } catch (e) {
        return {};
      }
      try {
        let SkilTypeList = await getSkillTypeList();
        setSkill(SkilTypeList);
      } catch (e) {
        return {};
      }
    })();
  }, []);
  return (
    <>
      <Form.List name={'Labor'}>
        {(Labor, { add, remove }) => {
          return (
            <Fragment>
              <Form.Item>
                <div style={{ display: 'flex', justifyContent: 'right', margin: "10px 0px" }}>
                  <Button
                    type="primary"
                    onClick={() => {
                      add();
                    }}
                  >
                    {translation(translationCache, constant.addLabor)}
                  </Button>
                </div>
              </Form.Item>
              {Labor && Array.isArray(Labor) && Labor.length > 0 ? (
                <Collapse accordion defaultActiveKey={[]}>
                  {Labor.map((labor, index2) => (
                    <Panel
                      key={index2}
                      header={
                        <div style={{ fontWeight: 'bold' }}>
                          {`${translation(translationCache, constant.labor)} ${index2 + 1}`}
                        </div>
                      }
                      extra={
                        <Popconfirm
                          title={translation(translationCache, constant.deleteLabor)}
                          icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                          onConfirm={() => remove(labor.name)}
                          okText={translation(translationCache, constant.yes)}
                          cancelText={translation(translationCache, constant.no)}
                        >
                          <Tooltip
                            title={translation(translationCache, 'Delete')}
                            placement="bottom"
                          >
                            <DeleteOutlined />
                          </Tooltip>
                        </Popconfirm>
                      }
                    >
                      <StyledBox>
                        <Form.Item
                          label={translation(translationCache, constant.labor)}

                          {...labor}
                          name={[labor.name, 'LaborId']}
                          fieldKey={[labor.fieldKey, 'LaborId']}
                          key={index2}
                          rules={[
                            {
                              required: true,
                              message: 'ManPower is Required'
                            }
                          ]}
                        >
                          <Select
                            style={{ width: '100%' }}
                            onChange={(value) =>
                              props.onLaborChange(
                                value,
                                index2,
                                'Labor',
                                laborsList.filter((Item) => Item.Id === value)
                              )
                            }
                            placeholder={translation(translationCache, 'Select Manpower')}
                          >
                            {laborsList.map((laborItem, index) => {
                              return (
                                <Option
                                  key={index}
                                  value={laborItem.Id}
                                  disabled={
                                    props.formHeader &&
                                      props.formHeader.current &&
                                      props.formHeader.current.getFieldValue() &&
                                      props.formHeader.current.getFieldValue().Labor &&
                                      props.formHeader.current
                                        .getFieldValue()
                                        .Labor.filter((item) => item && item.LaborId === laborItem.Id)
                                        .length > 0
                                      ? true
                                      : false
                                  }
                                >
                                  {' '}
                                  {laborItem.FirstName}{' '}
                                </Option>
                              );
                            })}
                          </Select>
                        </Form.Item>

                        <Form.Item

                          label={translation(translationCache, constant.Skill)}
                          {...labor}
                          name={[labor.name, 'SkillTypeName']}
                          fieldKey={[labor.fieldKey, 'SkillTypeName']}
                          key={index2}
                        >

                          <InputComponent
                            placeholder={translation(
                              translationCache,
                              'AutoPopulate from Manpower'
                            )}
                            style={{ width: '100%' }}
                            disabled
                          />
                        </Form.Item>
                        <Form.Item
                          label={translation(translationCache, constant.Quantity)}
                          validateTrigger={['onChange', 'onBlur']}
                          {...labor}

                          name={[labor.name, 'Quantity']}
                          fieldKey={[labor.fieldKey, 'Quantity']}
                          key={index2}
                          rules={[
                            // {
                            //   // pattern: new RegExp(/^[0-9]*$/),
                            //   message: 'field accept only numbers'
                            // },
                            {
                              validator: (_, value) =>
                                checkTask(_, value, 'Labor', index2, props.formObject, {
                                  validateDecimal: true
                                })
                            }
                          ]}
                        >
                          <InputNumberComponent
                            // min={0}
                            // max={1000}
                            disabled={
                              props &&
                                props.formObject &&
                                props.formObject.Labor &&
                                props.formObject.Labor[index2] === undefined
                                ? true
                                : false
                            }
                            placeholder={translation(translationCache, 'Input Quantity')}
                            style={{ width: '100%' }}
                            addonAfter={
                              <Tooltip
                                style={{ flex: '50%' }}
                                labelCol={{ flex: '130px' }}
                                title={translation(
                                  translationCache,
                                  'AvailableQuantity  -  ' +
                                  (props &&
                                    props.formObject &&
                                    props.formObject.Labor &&
                                    props.formObject.Labor[index2] &&
                                    props.formObject.Labor[index2].AvailableQuantity
                                    ? props.formObject.Labor[index2].AvailableQuantity
                                    : 'Not Available')
                                )}
                              >
                                <QuestionCircleOutlined />
                              </Tooltip>
                            }
                          //maxLength={10}
                          />
                        </Form.Item>
                        <Form.Item name={[labor.name, 'AvailableQuantity']} />
                      </StyledBox>
                    </Panel>
                  ))}
                </Collapse>
              ) : null}
            </Fragment>
          );
        }}
      </Form.List>
    </>
  );
};
const MaterialFormFunction = (props) => {
  const [materialsList, setTool] = useState([]);
  const [translationCache, settranslationCache] = useState(props.translationCache || {});
  useEffect(() => {
    (async () => {
      try {
        let response = await getMaterialsList();
        setTool(response.data);
      } catch (e) {
        return {};
      }
    })();
  }, []);
  return (
    <>
      <Form.List name={'Materials'}>
        {(Material, { add, remove }) => {
          return (
            <Fragment>
              <Form.Item>
                <div style={{ display: 'flex', justifyContent: 'right', margin: "10px 0px" }}>
                  <Button
                    type="primary"
                    onClick={() => {
                      add();
                    }}
                  >
                    {translation(translationCache, constant.addMaterial)}
                  </Button>
                </div>
              </Form.Item>
              {Material && Array.isArray(Material) && Material.length > 0 ? (
                <Collapse accordion defaultActiveKey={[]}>
                  {Material.map((material, index2) => (
                    <Panel
                      key={index2}
                      header={
                        <div style={{ fontWeight: 'bold' }}>
                          {`${translation(translationCache, constant.material)} ${index2 + 1}`}
                        </div>
                      }
                      extra={
                        <Popconfirm
                          title={translation(translationCache, constant.deleteMaterial)}
                          icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                          onConfirm={() => remove(material.name)}
                          okText={translation(translationCache, constant.yes)}
                          cancelText={translation(translationCache, constant.no)}
                        >
                          <Tooltip
                            title={translation(translationCache, 'Delete')}
                            placement="bottom"
                          >
                            <DeleteOutlined />
                          </Tooltip>
                        </Popconfirm>
                      }
                    >
                      <StyledBox>
                        <Form.Item
                          label={translation(translationCache, constant.material)}

                          {...material}
                          name={[material.name, 'MaterialId']}
                          fieldKey={[material.fieldKey, 'MaterialId']}
                          key={index2}
                          rules={[
                            {
                              required: true,
                              message: 'Material is Required'
                            }
                          ]}
                        >
                          <Select
                            style={{ width: '100%' }}
                            onChange={(value) =>
                              props.onMaterialChange(
                                value,
                                index2,
                                'Materials',
                                materialsList.filter((Item) => Item.Id === value)
                              )
                            }
                            placeholder={translation(translationCache, 'Select Material')}
                          >
                            {materialsList.map((material, index) => {
                              return (
                                <Option
                                  key={index}
                                  value={material.Id}
                                  disabled={
                                    props.formHeader &&
                                      props.formHeader.current &&
                                      props.formHeader.current.getFieldValue() &&
                                      props.formHeader.current.getFieldValue().Materials &&
                                      props.formHeader.current
                                        .getFieldValue()
                                        .Materials.filter(
                                          (item) => item && item.MaterialId === material.Id
                                        ).length > 0
                                      ? true
                                      : false
                                  }
                                >
                                  {material.Material}
                                </Option>
                              );
                            })}
                          </Select>
                        </Form.Item>
                        <Form.Item
                          label={translation(translationCache, 'Description')}
                          {...material}

                          name={[material.name, 'Description']}
                          fieldKey={[material.fieldKey, 'Description']}
                          key={index2}
                        >
                          <InputComponent
                            //maxLength={20}
                            placeholder={translation(
                              translationCache,
                              'AutoPopulate from Material'
                            )}
                            style={{ width: '100%' }}
                            disabled
                          />
                        </Form.Item>

                        <Form.Item
                          label={translation(translationCache, constant.Quantity)}
                          validateTrigger={['onChange', 'onBlur']}
                          {...material}

                          name={[material.name, 'Quantity']}
                          fieldKey={[material.fieldKey, 'Quantity']}
                          key={index2}
                          rules={[
                            // {
                            //   // pattern: new RegExp(/^[0-9]*$/),
                            //   message: 'field accept only numbers'
                            // },
                            {
                              validator: (_, value) =>
                                checkTask(_, value, 'Materials', index2, props.formObject, {
                                  validateDecimal: true
                                })
                            }
                          ]}
                        >
                          <InputNumberComponent
                            // min={0}
                            // max={1000}
                            disabled={
                              props &&
                                props.formObject &&
                                props.formObject.Materials &&
                                props.formObject.Materials[index2] === undefined
                                ? true
                                : false
                            }
                            placeholder={translation(translationCache, 'Input Quantity')}
                            style={{ width: '100%' }}
                            addonAfter={
                              <Tooltip
                                style={{ flex: '50%' }}
                                labelCol={{ flex: '130px' }}
                                title={translation(
                                  translationCache,
                                  'AvailableQuantity  -  ' +
                                  (props &&
                                    props.formObject &&
                                    props.formObject.Materials &&
                                    props.formObject.Materials[index2] &&
                                    props.formObject.Materials[index2].AvailableQuantity
                                    ? props.formObject.Materials[index2].AvailableQuantity
                                    : 'Not Available')
                                )}
                              >
                                <QuestionCircleOutlined />
                              </Tooltip>
                            }
                          //maxLength={10}
                          />
                        </Form.Item>
                        <Form.Item
                          name={[material.name, 'AvailableQuantity']}
                        >
                        </Form.Item>
                      </StyledBox>
                    </Panel>
                  ))}
                </Collapse>
              ) : null}
            </Fragment>
          );
        }}
      </Form.List>
    </>
  );
};
const ItemFormFunction = (props) => {
  const [itemsList, setItem] = useState([]);
  const [translationCache, settranslationCache] = useState(props.translationCache || {});
  useEffect(() => {
    (async () => {
      try {
        let response = await getItemsList();
        setItem(response.data);
      } catch (e) {
        return {};
      }
    })();
  }, []);
  return (
    <>
      <Form.List name={'Items'}>
        {(Items, { add, remove }) => {
          return (
            <Fragment>
              <Form.Item>
                <div style={{ display: 'flex', justifyContent: 'right', margin: "10px 0px" }}>
                  <Button
                    type="primary"
                    onClick={() => {
                      add();
                    }}
                  >
                    {translation(translationCache, constant.addItems)}
                  </Button>
                </div>
              </Form.Item>
              {Items && Array.isArray(Items) && Items.length > 0 ? (
                <Collapse accordion defaultActiveKey={[]}>
                  {Items.map((item, index2) => (
                    <Panel
                      key={index2}
                      header={
                        <div style={{ fontWeight: 'bold' }}>
                          {`${translation(translationCache, constant.item)} ${index2 + 1}`}
                        </div>
                      }
                      extra={
                        <Popconfirm
                          title={translation(translationCache, constant.deleteItem)}
                          icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                          onConfirm={() => remove(item.name)}
                          okText={translation(translationCache, constant.yes)}
                          cancelText={translation(translationCache, constant.yes)}
                        >
                          <Tooltip
                            title={translation(translationCache, 'Delete')}
                            placement="bottom"
                          >
                            <DeleteOutlined />
                          </Tooltip>
                        </Popconfirm>
                      }
                    >
                      <StyledBox>
                        <Form.Item
                          label={translation(translationCache, constant.item)}

                          {...item}
                          name={[item.name, 'ItemId']}
                          fieldKey={[item.fieldKey, 'ItemId']}
                          key={index2}
                          rules={[
                            {
                              required: true,
                              message: 'Item is Required'
                            }
                          ]}
                        >
                          <Select
                            style={{ width: '100%' }}
                            onChange={(value) =>
                              props.onItemChange(
                                value,
                                index2,
                                'Items',
                                itemsList.filter((tool) => tool.Id === value)
                              )
                            }
                            placeholder={translation(translationCache, 'Select Item')}
                          >
                            {itemsList.map((item, index) => {
                              return (
                                <Option
                                  key={index}
                                  value={item.Id}
                                  disabled={
                                    props.formHeader &&
                                      props.formHeader.current &&
                                      props.formHeader.current.getFieldValue() &&
                                      props.formHeader.current.getFieldValue().Items &&
                                      props.formHeader.current
                                        .getFieldValue()
                                        .Items.filter((text) => text && text.ItemId === item.Id)
                                        .length > 0
                                      ? true
                                      : false
                                  }
                                >
                                  {item.Item}
                                </Option>
                              );
                            })}
                          </Select>
                        </Form.Item>
                        <Form.Item
                          label={translation(translationCache, 'Description')}
                          {...item}

                          name={[item.name, 'Description']}
                          fieldKey={[item.fieldKey, 'Description']}
                          key={index2}
                        >
                          <InputComponent
                            placeholder={translation(translationCache, 'AutoPopulate from Item')}
                            style={{ width: '100%' }}
                            //maxLength={20}
                            disabled
                          />
                        </Form.Item>
                       
                        <Form.Item
                          label={translation(translationCache, constant.Quantity)}
                          validateTrigger={['onChange', 'onBlur']}
                          {...item}

                          name={[item.name, 'Quantity']}
                          fieldKey={[item.fieldKey, 'Quantity']}
                          key={index2}
                          rules={[
                            // {
                            //   // pattern: new RegExp(/^[0-9]*$/),
                            //   message: 'field accept only numbers'
                            // },
                            {
                              validator: (_, value) =>
                                checkTask(_, value, 'Items', index2, props.formObject, {
                                  validateDecimal: true
                                })
                            }
                          ]}
                        >
                          <InputNumberComponent
                            // min={0}
                            // max={1000}
                            disabled={
                              props &&
                                props.formObject &&
                                props.formObject.Items &&
                                props.formObject.Items[index2] === undefined
                                ? true
                                : false
                            }
                            placeholder={translation(translationCache, constant.inputQuantity)}
                            style={{ width: '100%' }}
                            addonAfter={
                              <Tooltip
                                style={{ marginRight: '20px', flex: '50%' }}
                                labelCol={{ flex: '130px' }}
                                title={translation(
                                  translationCache,
                                  'AvailableQuantity  -  ' +
                                  (props &&
                                    props.formObject &&
                                    props.formObject.Items &&
                                    props.formObject.Items[index2] &&
                                    props.formObject.Items[index2].AvailableQuantity
                                    ? props.formObject.Items[index2].AvailableQuantity
                                    : 'Not Available')
                                )}
                              >
                                <QuestionCircleOutlined />
                              </Tooltip>
                            }
                          //maxLength={10}
                          />
                        </Form.Item>
                         <Form.Item
                          name={[item.name, 'AvailableQuantity']}
                      
                        >
                        
                        </Form.Item>
                       
                      </StyledBox>
                    </Panel>
                  ))}
                </Collapse>
              ) : null}
            </Fragment>
          );
        }}
      </Form.List>
    </>
  );
};
const FieldDataTypeFormFunction = (props) => {
  const formHeader = props.formHeader;
  const [usersList, setUsersList] = useState([]);
  const [uomList, setUomList] = useState([]);
  const [formObject, setFormObject] = useState(props.formObject);

  const [translationCache, settranslationCache] = useState(props.translationCache || {});
  useEffect(() => {
    (async () => {
      try {
        const usersList = await getUsersList();
        setUsersList(usersList);
      } catch (error) {
        message.warn(`${error.message}`);
      }
      try {
        const uomList = await _getUOMList();
        setUomList(uomList);
      } catch (error) {
        message.warn(`${error.message}`);
      }
      // try {
      //   let response = await getItemsList();
      //   setItem(response.data);
      // } catch (e) {
      //   return {};
      // }
    })();
  }, []);
  const fileupload = async (values, key, fileDataObject) => {
    let formObject = formHeader.current.getFieldsValue();
    if (formObject && formObject[key]) {
      formObject[key].push(...values);
    } else {
      formObject[key] = values;
    }
    // Removing duplicate file names
    formObject[key] = formObject[key].reduce((acc, current) => {
      const x = acc.find((item) => item.Name === current.Name);
      if (!x) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, []);
    formObject = {
      ...formObject,
      [key]: formObject[key]
    };
    fileData.append('files', fileDataObject);
    formHeader.current.setFieldsValue(formObject);
    setFormObject(formObject);
  };
  return (
    <>
      <Form.List name={'FieldDataType'}>
        {(FieldDataType, { add, remove }) => {
          return (
            <Fragment>
              <Form.Item>
                <div style={{ display: 'flex', justifyContent: 'right', margin: "10px 0px" }}>
                  <Button
                    type="primary"
                    onClick={() => {
                      add();
                    }}
                  >
                    {translation(translationCache, constant.addTasks)}
                  </Button>
                </div>
              </Form.Item>
              {FieldDataType && Array.isArray(FieldDataType) && FieldDataType.length > 0 ? (
                <Collapse accordion defaultActiveKey={[]}>
                  {FieldDataType.map((item, index2) => (
                    <Panel
                      key={index2}
                      header={
                        <div style={{ fontWeight: 'bold' }}>
                          {`${translation(translationCache, constant.FieldDataType)} ${index2 + 1}`}
                        </div>
                      }
                      extra={
                        <Popconfirm
                          title={translation(translationCache, constant.deleteFdt)}
                          icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                          onConfirm={() => remove(item.name)}
                          okText={translation(translationCache, constant.yes)}
                          cancelText={translation(translationCache, constant.no)}
                        >
                          <Tooltip
                            title={translation(translationCache, 'Delete')}
                            placement="bottom"
                          >
                            <DeleteOutlined />
                          </Tooltip>
                        </Popconfirm>
                      }
                    >
                      <StyledBox>
                        <Form.Item
                          label={translation(translationCache, constant.Taskitem)}

                          {...item}
                          name={[item.name, 'Name']}
                          fieldKey={[item.fieldKey, 'Name']}
                          key={index2}
                          rules={[
                            {
                              required: true,
                              message: 'Task Item is Required'
                            }
                          ]}
                        >
                          <InputComponent
                            placeholder={translation(translationCache, 'Enter Task')}
                            // value={formObject.Name}
                            style={{ width: '100%' }}
                          //maxLength={30}
                          />
                        </Form.Item>
                        <Form.Item
                          label={translation(translationCache, 'Task Description')}
                          {...item}

                          name={[item.name, 'Description']}
                          fieldKey={[item.fieldKey, 'Description']}
                          key={index2}
                          rules={[
                            {
                              required: true,
                              message: 'Task Description is Required'
                            }
                          ]}
                        >
                          <InputComponent
                            placeholder={translation(translationCache, 'Enter Description')}
                            // value={formObject.Description}
                            style={{ width: '100%' }}
                          //maxLength={100}
                          />
                        </Form.Item>
                        {/* <Form.Item
                          style={{ width: '100%', flex: '50%' }}
                          label={translation(translationCache, constant.measurementDate)}
                          name="MeasurementDate"
                          rules={[{ required: false }]}
                        >
                          <DatePicker
                            style={{ width: '70%' }}
                            disabledDate={(d) => d.isBefore(moment().format('YYYY-MM-DD'))}
                            placeholder={translation(translationCache,"Select Actual End Date Time")}
                            format="YYYY-MM-DD"
                          />
                        </Form.Item> */}
                        <Form.Item
                          label={translation(translationCache, 'Measurement Value')}
                          {...item}

                          name={[item.name, 'MeasurementValue']}
                          fieldKey={[item.fieldKey, 'MeasurementValue']}
                          key={index2}
                        >
                          <InputComponent
                            placeholder={translation(translationCache, 'Enter Measurement Value')}
                            // value={formObject.MeasurementValue}
                            style={{ width: '100%' }}
                          //maxLength={30}
                          />
                        </Form.Item>
                        <Form.Item
                          label={translation(translationCache, 'Unit Of Measure ')}
                          {...item}

                          name={[item.name, 'UOM']}
                          fieldKey={[item.fieldKey, 'UOM']}
                          key={index2}
                        >
                          <Select
                            placeholder={translation(translationCache, 'Select UOM')}
                            style={{ width: '100%' }}
                          >
                            {uomList.map((uom, index) => {
                              return (
                                <Option key={index} value={uom.UOM}>
                                  {' '}
                                  {uom.UOM}{' '}
                                </Option>
                              );
                            })}
                          </Select>
                        </Form.Item>
                        <Form.Item
                          // style={{ width: '100%', flex: '50%' }}
                          label={translation(translationCache, constant.inspectionMethod)}
                          {...item}

                          name={[item.name, 'Method']}
                          fieldKey={[item.fieldKey, 'Method']}
                          key={index2}
                        >
                          <InputComponent
                            placeholder={translation(translationCache, 'Enter Inspection Method')}
                            // value={formObject.InspectionMethod}
                            style={{ width: '100%' }}
                          //maxLength={30}
                          />
                        </Form.Item>
                        <Form.Item
                          label={translation(translationCache, constant.criterion)}
                          {...item}

                          name={[item.name, 'Criteria']}
                          fieldKey={[item.fieldKey, 'Criteria']}
                          key={index2}
                        >
                          <InputComponent
                            placeholder={translation(translationCache, 'Enter Criteria')}
                            // value={formObject.Criteria}
                            style={{ width: '100%' }}
                          //maxLength={30}
                          />
                        </Form.Item>
                        <Form.Item
                          label={translation(translationCache, constant.observation)}
                          {...item}

                          name={[item.name, 'Observation']}
                          fieldKey={[item.fieldKey, 'Observation']}
                          key={index2}
                        >
                          <InputComponent
                            placeholder={translation(translationCache, 'Enter Observation')}
                            // value={formObject.Observation}
                            style={{ width: '100%' }}
                          //maxLength={30}
                          />
                        </Form.Item>
                        {/* <Form.Item
                          style={{ width: '100%', flex: '50%' }}
                          label={translation(translationCache, constant.estimatedDuration)}
                          name="EstimatedDuration"
                        >
                          <InputComponent
                            disabled
                            placeholder={translation(translationCache,"Autopopulate EstimatedDuration  Basis To The Start & End Time")}
                            style={{ width: '70%' }}
                            //maxLength={10}
                          />
                        </Form.Item> */}
                        {/* <Form.Item
                          label={translation(translationCache, constant.attachments)}
                          
                          {...item}
                          name={[item.name, 'Attachments']}
                          fieldKey={[item.fieldKey, 'Attachments']}
                          key={index2}
                        >
                          <FileBase641
                            style={{ width: '100%' }}
                            downloadClassName={'formdownloadInput'}
                            Attachments={formObject.Attachments}
                            fileUpload={fileupload}
                          ></FileBase641>
                        </Form.Item> */}
                        <Form.Item
                          label={translation(translationCache, constant.recordedBy)}

                          {...item}
                          name={[item.name, 'RecordBy']}
                          fieldKey={[item.fieldKey, 'RecordBy']}
                          key={index2}
                        >
                          <Select
                            placeholder={translation(translationCache, 'Select RecordedBy')}
                            style={{ width: '100%' }}
                          >
                            {usersList &&
                              Array.isArray(usersList) &&
                              usersList.length > 0 &&
                              usersList.map((item, index) => {
                                return (
                                  <Option key={index} value={item.Id}>
                                    {' '}
                                    {item.FirstName}{' '}
                                  </Option>
                                );
                              })}
                          </Select>
                        </Form.Item>
                        <Form.Item

                          {...FieldDataType}
                        ></Form.Item>
                      </StyledBox>
                    </Panel>
                  ))}
                </Collapse>
              ) : null}
            </Fragment>
          );
        }}
      </Form.List>
    </>
  );
};
const ObservationTypeFormFunction = (props) => {
  const [itemsList, setItem] = useState([]);
  const [value, setValue] = useState(null);
  const formHeader = props.formHeader;
  const [formObject, setFormObject] = useState({});
  const [translationCache, settranslationCache] = useState(props.translationCache || {});
  useEffect(() => {
    (async () => {
      try {
        let response = await getItemsList();
        setItem(response.data);
      } catch (e) {
        return {};
      }
    })();
  }, []);
  const handleChange = (value, key) => {
    let formObject = formHeader.current.getFieldsValue();
    if (key === 'EstimatedDuration') {
      formObject = {
        ...formObject,
        [key]: dayjs(value, 'HH:mm')
      };
    }
    if (formHeader.current) {
      formHeader.current.setFieldsValue(formObject);
    }
    setFormObject(formObject);
  };
  const fileupload = async (values, key, fileDataObject) => {
    let formObject = formHeader.current.getFieldsValue();
    if (formObject && formObject[key]) {
      formObject[key].push(...values);
    } else {
      formObject[key] = values;
    }
    // Removing duplicate file names
    formObject[key] = formObject[key].reduce((acc, current) => {
      const x = acc.find((item) => item.Name === current.Name);
      if (!x) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, []);
    formObject = {
      ...formObject,
      [key]: formObject[key]
    };
    fileData.append('files', fileDataObject);
    formHeader.current.setFieldsValue(formObject);
    setFormObject(formObject);
  };
  return (
    <>
      <Form.List
        name={'ObservationType'}
        rules={[
          {
            validator: async (_, observationType) => {
              if (!observationType || observationType.length < 1) {
                return Promise.reject(new Error('At least one Observation must be added.'));
              }
            }
          }
        ]}
      >
        {(Observation, { add, remove }) => {
          return (
            <Fragment>
              <Form.Item>
                <div style={{ display: 'flex', justifyContent: 'right', margin: "10px 0px" }}>
                  <Button
                    type="primary"
                    onClick={() => {
                      add();
                    }}
                  >
                    {translation(translationCache, constant.addTasks)}
                  </Button>
                </div>
              </Form.Item>
              {Observation && Array.isArray(Observation) && Observation.length > 0 ? (
                <Collapse accordion defaultActiveKey={[]}>
                  {Observation.map((item, index2) => (
                    <Panel
                      key={index2}
                      header={
                        <div style={{ fontWeight: 'bold' }}>
                          {`${translation(translationCache, constant.ObservationType)} ${index2 + 1
                            }`}
                        </div>
                      }
                      extra={
                        <Popconfirm
                          title={translation(translationCache, constant.deleteObservationType)}
                          icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                          onConfirm={() => remove(item.name)}
                          okText={translation(translationCache, constant.yes)}
                          cancelText={translation(translationCache, constant.no)}
                        >
                          <Tooltip
                            title={translation(translationCache, 'Delete')}
                            placement="bottom"
                          >
                            <DeleteOutlined />
                          </Tooltip>
                        </Popconfirm>
                      }
                    >
                      <StyledBox>
                        <Form.Item
                          label={translation(translationCache, constant.taskItem)}
                         {...item}
                          name={[item.name, 'Name']}
                          fieldKey={[item.fieldKey, 'Name']}
                          key={index2}
                          rules={[
                            {
                              required: true,
                              message: 'Task Item is Required'
                            }
                          ]}
                        >
                          <InputComponent
                            placeholder={translation(translationCache, 'Enter Name')}
                            value={formObject.Name}
                            style={{ width: '100%' }}
                          />
                        </Form.Item>
                        <Form.Item
                          label={translation(translationCache, constant.taskDescription)}
                          {...item}

                          name={[item.name, 'Description']}
                          fieldKey={[item.fieldKey, 'Description']}
                          key={index2}
                          rules={[
                            {
                              required: true,
                              message: 'Task Description is Required'
                            }
                          ]}
                        >
                          <InputComponent
                            placeholder={translation(translationCache, 'Enter Description')}
                            style={{ width: '100%' }}
                          //maxLength={150}
                          />
                        </Form.Item>
                        <Form.Item
                          label={translation(translationCache, constant.criterion)}
                          {...item}

                          name={[item.name, 'Criteria']}
                          fieldKey={[item.fieldKey, 'Criteria']}
                          key={index2}
                        >
                          <InputComponent
                            placeholder={translation(translationCache, 'Enter Criteria')}
                            style={{ width: '100%' }}
                          //maxLength={30}
                          />
                        </Form.Item>
                        <Form.Item
                          label={translation(translationCache, constant.method)}
                          {...item}

                          name={[item.name, 'Method']}
                          fieldKey={[item.fieldKey, 'Method']}
                          key={index2}
                        >
                          <InputComponent
                            placeholder={translation(translationCache, 'Enter Method')}
                            style={{ width: '100%' }}
                          //maxLength={30}
                          />
                        </Form.Item>
                        <Form.Item
                          label={translation(translationCache, constant.observation)}
                          {...item}

                          name={[item.name, 'Observation']}
                          fieldKey={[item.fieldKey, 'Observation']}
                          key={index2}
                        >
                          <InputComponent
                            placeholder={translation(translationCache, 'Enter Observation')}
                            style={{ width: '100%' }}
                          //maxLength={30}
                          />
                        </Form.Item>
                        <Form.Item
                          label={translation(translationCache, constant.estimatedDuration)}
                          {...item}

                          name={[item.name, 'EstimatedDuration']}
                          fieldKey={[item.fieldKey, 'EstimatedDuration']}
                          key={index2}
                        >
                          <TimePicker
                            style={{ width: '100%' }}
                            format={'HH:mm'}
                            allowClear={false}
                            onChange={(value) => handleChange(value, 'EstimatedDuration')}
                          />
                        </Form.Item>
                      
                        <Form.Item
                          label={translation(translationCache, constant.remarks)}

                          {...item}
                          name={[item.name, 'Remarks']}
                          fieldKey={[item.fieldKey, 'Remarks']}
                          key={index2}
                        >
                          <TextArea
                            placeholder={translation(translationCache, 'Enter Remarks')}
                            style={{ width: '100%' }}
                          //maxLength={100}
                          />
                        </Form.Item>
                        
                        <Form.Item name="Equipment"></Form.Item>
                      </StyledBox>
                    </Panel>
                  ))}
                </Collapse>
              ) : null}
            </Fragment>
          );
        }}
      </Form.List>
    </>
  );
};
const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache,
});
const ToolsForm = connect(mapStateToProps)(ToolsFormFunction);
const LaborForm = connect(mapStateToProps)(LaborFormFunction);
const MaterialForm = connect(mapStateToProps)(MaterialFormFunction);
const ItemForm = connect(mapStateToProps)(ItemFormFunction);
const FieldDataType = connect(mapStateToProps)(FieldDataTypeFormFunction);
const ObservationType = connect(mapStateToProps)(ObservationTypeFormFunction);
export { ToolsForm, LaborForm, MaterialForm, ItemForm, FieldDataType, ObservationType };
